import React, { Fragment, Suspense } from "react"
import Alert from "./tailwind/Alert"

interface IFlexibleContentProps {
  blocks: any
  rows: any
  /**
   * Extra data that will be passed to each individual component
   */
  data: any
  /**
   * Enables Suspense and wraps each component with a Suspense component
   */
  suspense?: boolean

  /**
   * Additional props to pass to the Suspense wrapper components
   */
  suspenseProps?: {
    fallback?: boolean
    unstable_avoidThisFallback?: boolean
    [x: string]: any
  }
}

export const FlexibleContent = ({
  blocks,
  rows,
  data,
  suspense = false,
  suspenseProps = { fallback: false },
}: IFlexibleContentProps) => {
  if (!!rows) {
    return rows
      .filter(o => o !== null)
      .map(({ __typename, ...rest }: any, index: number) => {
        const type = __typename.split("_").slice(-1)[0]

        const rowData = { __typename, type, ...rest }

        const Component = blocks?.[type]

        const el = Component ? (
          <Component
            key={index}
            firstItem={index === 0}
            {...rowData}
            {...data}
          />
        ) : (
          <Alert
            className="max-w-7xl"
            title={`Error loading module "${type}"`}
            content={`React component "${type}" was not found. Make sure the component exists and you are importing it.`}
            html={
              <pre
                className={
                  " w-full break-normal mt-4 bg-red-100	border border-solid border-red-200 rounded-md	p-5"
                }
              >
                {rowData && JSON.stringify(rowData, undefined, 2)}
              </pre>
            }
          />
        )

        if (suspense) {
          return (
            <Suspense key={index} {...suspenseProps}>
              {el}
            </Suspense>
          )
        } else {
          return <Fragment key={index}>{el}</Fragment>
        }
      })
  } else {
    return null
  }
}

export default FlexibleContent
